import * as tslib_1 from "tslib";
import { Button } from '@nextiva/next-ui';
import { map } from 'lodash';
import * as React from 'react';
import SingleSelectable from '../SingleSelectable';
import Styles from "./SetsSelectable.css";

var SetsSelectable =
/** @class */
function (_super) {
  tslib_1.__extends(SetsSelectable, _super);

  function SetsSelectable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      activeCategorySet: null
    };

    _this.selectCategorySet = function (activeCategorySet) {
      _this.setState({
        activeCategorySet: activeCategorySet
      });
    };

    _this.getCategoryName = function (categoryId) {
      var categories = _this.props.categories;
      var category = categories.find(function (cat) {
        return cat.id === categoryId;
      });
      return category && category.name;
    };

    _this.handleDelete = function () {
      _this.props.onDelete(_this.state.activeCategorySet);

      _this.setState({
        activeCategorySet: null
      });
    };

    _this.handleApply = function () {
      var _a = _this.props,
          goToTab = _a.goToTab,
          togglePopover = _a.togglePopover,
          onApply = _a.onApply;
      onApply(_this.state.activeCategorySet);
      goToTab(0);
      togglePopover();
    };

    return _this;
  }

  SetsSelectable.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        categorySets = _a.categorySets,
        beforeCategorySets = _a.beforeCategorySets,
        togglePopover = _a.togglePopover;
    var activeCategorySet = this.state.activeCategorySet;
    return React.createElement("div", {
      className: Styles.setsSelectable,
      "data-test": "sets-selectable"
    }, React.createElement(SingleSelectable, {
      isCategories: true,
      allowSearch: true,
      options: categorySets,
      beforeList: beforeCategorySets,
      activeCategoryId: activeCategorySet ? activeCategorySet.id : undefined,
      handlerClick: this.selectCategorySet,
      theme: {
        singleSelectable: Styles.singleSelectable
      }
    }), activeCategorySet && activeCategorySet.categories && React.createElement("div", {
      className: Styles.view
    }, React.createElement("div", {
      className: Styles.name
    }, activeCategorySet.name), React.createElement("div", {
      className: Styles.categories
    }, map(activeCategorySet.categories, function (options, categoryId) {
      return React.createElement("div", {
        key: categoryId,
        className: Styles.category
      }, React.createElement("span", {
        className: Styles.categoryName
      }, _this.getCategoryName(categoryId)), options.map(function (opt) {
        return opt.name;
      }).join(', '));
    })), React.createElement("div", {
      className: Styles.controls
    }, React.createElement(Button, {
      onClick: togglePopover
    }, "Cancel"), React.createElement(Button, {
      onClick: this.handleDelete
    }, "Delete"), React.createElement(Button, {
      kind: "success",
      onClick: this.handleApply
    }, "Apply filter"))));
  };

  return SetsSelectable;
}(React.PureComponent);

export default SetsSelectable;